export type StudioEntityType = 'asset' | 'component' | 'scene' | 'playlist';

export const dragIds = {
    panel: (index: number) => `panel:${index}`,
} as const;
